module.exports = __webpack_public_path__ + "static/media/collapse-all.7a6e6c74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/collapse-all.svg
// module id = 1957
// module chunks = 1